import { blogUrl } from "../lib/siteUrls";

// Mock data for Sky's The Limit clone

export const NAV_LINKS = [
  { label: 'About', href: '/about', children: [
    { label: 'About', href: '/about' },
    { label: 'Our Team', href: '/our-team' },
    { label: 'Communities', href: '/communities' },
    { label: 'News', href: blogUrl('/') },
  ] },
  { label: 'Entrepreneurs', href: '/entrepreneurs', children: [
    { label: 'Entrepreneurs', href: '/entrepreneurs' },
    { label: 'Grants', href: '/entrepreneur-grants' },
    { label: 'Launchpad Accelerator', href: '/launchpad' },
  ] },
  { label: 'Corporate Partnerships', href: '/partnerships', children: [
    { label: 'Corporate Partnerships', href: '/partnerships' },
    { label: 'Accenture Case Study', href: '/accenture-case-study' },
  ] },
  { label: 'Volunteers', href: '/supporters', children: [
    { label: 'Volunteers', href: '/supporters' },
    { label: 'Mentorship Guide', href: '/mentorship-guide' },
  ] },
  { label: 'Nonprofit Partnerships', href: '/powered-by' },
  { label: 'Success Stories', href: '/success-stories' },
];

export const PARTNERS = [
  { name: 'Accenture', logo: '/hubfs/STL_Theme_July_2023/Accenture%20Logo.png' },
  { name: 'eBay', logo: '/hubfs/Partners%20Logo%20-%20ebay.png' },
  { name: 'Goldman Sachs', logo: '/hubfs/Partners%20Logo%20-%20Goldman%20Sachs.png' },
  { name: 'Bank of America', logo: '/hubfs/Bank%20of%20America%20Logo.jpg' },
  { name: 'HP', logo: '/hubfs/Partners%20Logo%20-%20HP.png' },
  { name: 'PNC', logo: '/hubfs/Partners%20Logo%20-%20PNC.png' },
  { name: 'CVC', logo: '/hubfs/CVC%20Logo.jpg' },
  { name: 'Wells Fargo', logo: '/hubfs/Partners%20Logo%20-%20Wells%20Fargo.png' },
];

export const SOLUTIONS = [
  {
    id: 'entrepreneurs',
    label: 'FOR ENTREPRENEURS',
    title: 'Turn Your Vision Into a Thriving Business',
    description: 'Leverage free expert mentorship and training to launch a business and access $850K+ in start-up grants awarded to idea-stage entrepreneurs.',
    bullets: [
      'Guidance from experienced volunteers',
      'Access to grants and business resources',
      'Join a purpose-driven community',
    ],
    primaryCta: { label: 'Get Started', href: '/entrepreneurs' },
    secondaryCta: { label: 'Learn More', href: '/entrepreneurs' },
    image: 'https://images.unsplash.com/photo-1573164713619-24c711fe7878?crop=entropy&cs=srgb&fm=jpg&q=85',
    accent: 'emerald',
  },
  {
    id: 'volunteers',
    label: 'FOR VOLUNTEER MENTORS',
    title: 'Share Your Expertise. Change a Life.',
    description: 'We match skilled professionals with entrepreneurs who need expert guidance across every discipline of building a business.',
    bullets: [
      'Make an impact in your community',
      'Gain mentoring & coaching experience',
      'Expand your professional network',
    ],
    primaryCta: { label: 'Volunteer', href: '/supporters' },
    secondaryCta: { label: 'Learn More', href: '/supporters' },
    image: 'https://images.unsplash.com/photo-1573497620053-ea5300f94f21?crop=entropy&cs=srgb&fm=jpg&q=85',
    accent: 'amber',
  },
  {
    id: 'corporate',
    label: 'FOR CORPORATE PARTNERS',
    title: 'Empower a Nation of Entrepreneurs',
    description: 'Partner with us to create meaningful opportunities for fresh ideas and realized dreams, while activating your workforce for good.',
    bullets: [
      'Empower your workforce',
      'Drive positive change at scale',
      'Align with genuine social impact',
    ],
    primaryCta: { label: 'Partner With Us', href: '/partnerships' },
    secondaryCta: { label: 'Learn More', href: '/partnerships' },
    image: 'https://images.unsplash.com/photo-1600880292089-90a7e086ee0c?crop=entropy&cs=srgb&fm=jpg&q=85',
    accent: 'sky',
  },
  {
    id: 'philanthropists',
    label: 'FOR PHILANTHROPISTS',
    title: 'Give Where It Multiplies',
    description: 'Make a meaningful impact in communities and achieve personal fulfillment, while unlocking financial advantages of strategic giving.',
    bullets: [
      'Create a lasting legacy',
      'Support causes you care about',
      'Multiply your impact 10x',
    ],
    primaryCta: { label: 'Donate', href: '/donate' },
    secondaryCta: { label: 'Learn More', href: '/donate' },
    image: 'https://images.unsplash.com/photo-1687422808248-f807f4ea2a2e?crop=entropy&cs=srgb&fm=jpg&q=85',
    accent: 'rose',
  },
];

export const FEATURES = [
  {
    id: 'community',
    label: 'COMMUNITY',
    title: 'A Purpose-Driven Community',
    description: 'Connect with founders and mentors from around the world to exchange ideas, gain support, and grow together, every day.',
    bullets: ['142,000+ active members', 'Global network of founders', 'Curated matches by industry & stage'],
    image: 'https://images.unsplash.com/photo-1573164574511-73c773193279?crop=entropy&cs=srgb&fm=jpg&q=85',
  },
  {
    id: 'assists',
    label: 'ASSISTS',
    title: 'Wisdom, Advice & Feedback',
    description: 'Get on-demand expert guidance from skilled volunteers and peers, from pitch decks to pricing to product-market fit.',
    bullets: ['1:1 mentor requests', 'Peer feedback loops', 'Skill-based matching'],
    image: 'https://images.unsplash.com/photo-1551836022-4c4c79ecde51?crop=entropy&cs=srgb&fm=jpg&q=85',
  },
  {
    id: 'pitches',
    label: 'PITCHES',
    title: 'Win Grant Funding for Your Big Idea',
    description: 'Pitch your business and win non-dilutive grants distributed monthly, no equity required, no strings attached.',
    bullets: ['$850K+ awarded to date', 'Monthly pitch competitions', 'Idea-stage friendly'],
    image: 'https://images.unsplash.com/photo-1578574577315-3fbeb0cecdc2?crop=entropy&cs=srgb&fm=jpg&q=85',
  },
  {
    id: 'groups',
    label: 'GROUPS',
    title: 'Join a Group or Build Your Own',
    description: 'Find your people. Join community groups by identity, industry, city or stage, or launch a new one and lead the tribe.',
    bullets: ['Identity-based groups', 'Industry cohorts', 'City meetups'],
    image: 'https://images.pexels.com/photos/8117545/pexels-photo-8117545.jpeg',
  },
  {
    id: 'milestones',
    label: 'MILESTONES',
    title: 'Track Every Victory',
    description: 'Keep a beautiful record of your business milestones, celebrate wins with your community, and stay accountable.',
    bullets: ['Visual milestone board', 'Celebrate with community', 'Founder journey timeline'],
    image: 'https://images.unsplash.com/photo-1551836022-d5d88e9218df?crop=entropy&cs=srgb&fm=jpg&q=85',
  },
];

export const IMPACT_STATS = [
  { value: '142,000+', label: 'Entrepreneurs served on our platform' },
  { value: '45,000+', label: 'Entrepreneurs mentored 1:1 and in groups' },
  { value: '22,700+', label: 'Entrepreneurs launched or grew a business' },
  { value: '32,800+', label: 'Jobs created by STL entrepreneurs' },
  { value: '$850K+', label: 'In startup grants awarded' },
];

export const DEMOGRAPHICS = [
  { value: '92%', label: 'Low to moderate income' },
  { value: '68%', label: 'Women' },
  { value: '81%', label: 'Identify as BIPOC' },
  { value: '75%', label: 'Idea-stage entrepreneurs' },
];

export const COMMUNITY_GROUPS = [
  {
    slug: 'aapi',
    name: 'AAPI',
    image: '/hubfs/Cities%20Imagery/aapi.webp',
    description: 'AAPI entrepreneurs contribute rich cultural heritage from Asia and the Pacific Islands. Their innovation and community focus drive growth in technology, retail, and healthcare.',
  },
  {
    slug: 'bipoc',
    name: 'BIPOC',
    image: '/hubfs/Cities%20Imagery/bipoc-1.png',
    description: 'BIPOC entrepreneurs address systemic barriers while creating impactful ventures. Their contributions inspire communities and pave the way for future generations.',
  },
  {
    slug: 'lgbtq',
    name: 'LGBTQIA+',
    image: '/hubfs/Cities%20Imagery/lgbtq.webp',
    description: 'LGBTQ+ entrepreneurs use their unique perspectives to foster inclusivity and champion diversity in business across every industry.',
  },
  {
    slug: 'refugee',
    name: 'Refugee',
    image: '/hubfs/Cities%20Imagery/refugee.jpg',
    description: 'Refugee entrepreneurs turn the challenges of displacement into thriving businesses, contributing significantly to their new communities and economies.',
  },
  {
    slug: 'veteran',
    name: 'Veteran',
    image: '/hubfs/Cities%20Imagery/veterans.png',
    description: 'Veteran entrepreneurs bring discipline and leadership from military service to build resilient, mission-driven companies.',
  },
  {
    slug: 'women',
    name: 'Women',
    image: '/hubfs/Cities%20Imagery/women.webp',
    description: 'Women entrepreneurs lead startups and enterprises across sectors with creativity and resilience, setting new standards for the future of business.',
  },
];

export const SUCCESS_STORIES = [
  {
    id: 1,
    name: 'Andrea Etienne',
    title: 'Founder, Flock',
    link: '/success-stories/andrea-etienne',
    image: '/founders/andrea-etienne.webp',
    excerpt: 'Flock is a digital journaling platform built for real healing, real expression, and real community.',
    story: 'Founded by Andrea Etienne, Flock creates a shared space for processing trauma, building healthy wellness habits, and growing in faith, together. Andrea was inspired by her own lived pain and her search for accessible, affordable mental health support. Through Flock, she is making healing tools available to people who need them most.',
  },
  {
    id: 2,
    name: 'Tiffany Barnes',
    title: 'Founder, Tiny Town Adventurez',
    link: '/success-stories/tiffany-barnes',
    image: '/founders/tiffany-barnes.webp',
    excerpt: 'A family-owned boutique indoor play café for children ages 9 months to 8 years.',
    story: 'Tiffany and her family created a playful, imaginative, and developmentally supportive environment featuring soft-play zones, a pretend-play town, sensory-friendly areas, and enrichment events. Their mission is rooted in creating magical moments and meaningful memories through play.',
  },
  {
    id: 3,
    name: 'Titilope Olotu',
    title: 'Founder, PADÍ',
    link: '/success-stories/titilope-olotu',
    image: '/founders/titilope-olotu.webp',
    excerpt: 'A nonprofit and biotech startup focused on menstrual health, mental wellness, and financial literacy.',
    story: 'Titilope\'s team develops biodegradable banana fiber pads and biosensors that turn menstruation into valuable health data. PADÍ serves underserved communities across the U.S. Nigeria, and India, ensuring access to sustainable products and wellness education.',
  },
  {
    id: 4,
    name: 'Aliké Chambers',
    title: 'Founder, Oni Threads',
    link: '/success-stories/alike-chambers',
    image: '/founders/alike-chambers.webp',
    excerpt: 'A samurai-inspired streetwear brand creating “Armor for the Everyday Warrior”, wearable art rooted in Japanese art and lore.',
    story: 'Aliké Chambers is the founder of Oni Threads, a samurai-inspired streetwear brand rooted in authentic Japanese art and lore. Launching with no savings, loans, or capital was her biggest challenge, until she won her first-ever grant of $2,500 through Sky\u2019s the Limit Friends & Family Fund. That funding legitimized the business, allowed her to manufacture her first products, and paved the way for a sold-out launch. Through pitch practices and mentorship, Oni Threads is now a revenue-generating brand with a loyal customer base and a clear path to growth.',
  },
];

export const FAQS = [
  {
    q: "Are the services from Sky's the Limit free?",
    a: 'Yes! 100% free. We are a certified 501(c)(3) nonprofit organization in the US and a certified charity in the UK, which allows us to partner with our sponsors to bring you a premium entrepreneurship program at no cost to you.',
  },
  {
    q: 'How does it work?',
    a: 'Sky\'s the Limit is a mutually beneficial community of Supporters and Entrepreneurs, all focused on creating the next generation of thriving businesses. Once you sign up, you can request to "Connect" with other members. Once accepted, you can schedule meetings and work together on business challenges like your plan, customer acquisition, and more.',
  },
  {
    q: 'How do I get involved?',
    a: 'It\'s easy! Start by setting up your profile. Fill out as much information as you can, we use it to match you with entrepreneurs and mentors based on demographics, interests, and skills. The more complete your profile, the better your matches.',
  },
  {
    q: 'What kind of grants are available?',
    a: 'We distribute monthly non-dilutive startup grants ranging from $500 to $10,000, awarded through pitch competitions on the platform. To date we have distributed over $850,000 to idea-stage entrepreneurs, no equity required.',
  },
  {
    q: 'Who can become a volunteer mentor?',
    a: 'Anyone with professional experience or entrepreneurial expertise! Whether you\'re at a Fortune 1000 company, a seasoned founder, or just starting out with lessons to share, there is a founder who needs your perspective.',
  },
];

export const MEMBERS = [
  { name: 'Martin Magana-Reyes', business: 'Reyes Roastery', location: 'Los Angeles, CA', image: '/hubfs/Martin%20Magana-Reyes.png' },
  { name: 'Sarah Kim', business: 'Kim & Co Studio', location: 'Brooklyn, NY', image: 'https://images.unsplash.com/photo-1573497701240-345a300b8d36?crop=entropy&cs=srgb&fm=jpg&q=85&w=200' },
  { name: 'Amara Johnson', business: 'Amara Botanicals', location: 'Atlanta, GA', image: 'https://images.unsplash.com/photo-1573164713619-24c711fe7878?crop=entropy&cs=srgb&fm=jpg&q=85&w=200' },
  { name: 'David Okafor', business: 'Okafor Tech', location: 'Austin, TX', image: 'https://images.unsplash.com/photo-1622675363311-3e1904dc1885?crop=entropy&cs=srgb&fm=jpg&q=85&w=200' },
  { name: 'Priya Sharma', business: 'Sharma Threads', location: 'Chicago, IL', image: 'https://images.unsplash.com/photo-1520333789090-1afc82db536a?crop=entropy&cs=srgb&fm=jpg&q=85&w=200' },
  { name: 'Jamal Wright', business: 'Wright Consulting', location: 'Detroit, MI', image: 'https://images.unsplash.com/photo-1556740758-90de374c12ad?crop=entropy&cs=srgb&fm=jpg&q=85&w=200' },
];
